<template>
  <CHeader fixed with-subheader light>
    <CHeaderNav class="mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/">
          <img v-if="$router.currentRoute.path.startsWith('/plus')" src="/img/igrain/igrainplus-logo.png" style="height: 75px"/>
          <img v-else src="/img/igrain/igrain-logo.png" style="height: 75px"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <CHeaderNavItem v-if="shouldShowEnv">
        <CBadge @click="showEnvURL = !showEnvURL" :color="envTitle == 'DEV' ? 'info' : 'success'">{{ showEnvURL ? envURL : envTitle }}</CBadge>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink to="/search">
          Buy grain
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink to="/offer">
          Sell grain
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink to="/plus">
          <span style="font-weight: 700;">igrain</span>Plus
          <CBadge color="danger" style="top: 23px; left: 8px; margin: 0;">New</CBadge>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2" v-if="!isLoggedIn">
        <CHeaderNavLink to="/login">
          Sign in
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2" v-if="!isLoggedIn">
        <a href="https://www.cleargrain.com.au/register?source=igrain" target="_blank">
          <CButton color="primary" variant="outline">Register</CButton>
        </a>
      
      </CHeaderNavItem>
      <AccountDropdown :label="initials" class="d-md-down-none" v-if="isLoggedIn"/>
    </CHeaderNav>

    <div v-if="isLoggedIn" class="mr-4 d-lg-none" style="display: flex; justify-content: center; align-items: center;">
      <CLink @click="$store.commit('toggleSidebarMobile')"><Avatar :label="initials.toUpperCase()" /></CLink>
    </div>

    <CToggler 
      v-else
      in-header
      class="mr-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />

    <CSubheader v-if="$route.meta.showBreadcrumbs || $store.getters['auth/isAdminUser']" class="px-3">
      <CCol>
        <BreadcrumbRouter v-if="$route.meta.showBreadcrumbs" class="border-0 mb-0"/>
      </CCol>
      <CCol xl=4 lg=6 md=8 sm=12>
        <AdminBar style="margin-top: 6.5px; margin-bottom: 6.5px;" v-if="$store.getters['auth/isAdminUser']" />
      </CCol>
    </CSubheader>
  </CHeader>
</template>

<script>
import AccountDropdown from './AccountDropdown'
import Avatar from './Avatar'
import AdminBar from './AdminBar'
import BreadcrumbRouter from '@/views/components/BreadcrumbRouter'
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  components: {
    AccountDropdown,
    Avatar,
    BreadcrumbRouter,
    AdminBar
  },
  data () {
    return {
      showEnvURL: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn',
      'initials'
    ]),
    shouldShowEnv() {
      return this.envTitle == 'DEV' || this.envTitle == 'TEST'
    },
    envTitle() {
      return process.env.VUE_APP_BASE_URL.includes('dev') ? 'DEV' : process.env.VUE_APP_BASE_URL.includes('test') ? 'TEST' : 'PROD'
    },
    envURL() {
      return process.env.VUE_APP_BASE_URL
    }
  }
}
</script>
